<template>
  <div class="achievement-box">
    <div class="land-box">
      <!-- <div class="achievement-top">
        <span>徽章</span>
      </div> -->
      <a-spin class="list-spin" v-if="loading" tip="加载中..."></a-spin>
      <!-- 没有任何勋章 -->
      <div class="achievement-list" v-if="show_class.length == 0">
        <div class="achievement-item notshow" v-for="item of allAchievementList" @click="showAchievement = item">
          <i class="achievement-cover icon-i" :style="{ backgroundImage: 'url(' + item.cover + ')' }"></i>
        </div>
      </div>
      <!-- 按班级分 -->
      <div class="class-list" v-else>
        <div class="class-item" v-for="sc of show_class">
          <div class="class-name-box">
            <div class="class-name">{{ sc.class_name }}</div>
            <div class="level-box" v-if="sc.levelInfo">
              <div>学习等级：</div>
              <div class="user-level">
                <span>LV.{{ sc.levelInfo?.value || 0 }}</span>
                <a-progress class="level-progress" strokeColor="#000000" :percent="sc.levelInfo?.EXPProcess"
                  :strokeWidth="5" :show-info="false" />
                <span class="level-value" v-if="sc.levelInfo?.upgradeEXP">{{ sc.levelInfo?.EXP }}/{{
                  sc.levelInfo?.upgradeEXP
                }}</span>
              </div>
            </div>
          </div>
          <div class="achievement-list">
            <div class="achievement-item " v-for="item of sc.achievement" @click="showAchievement = item">
              <i class="achievement-cover icon-i" :style="{ backgroundImage: 'url(' + item.cover + ')' }"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <showAchievement :showAchievement="showAchievement" type="show" @closeBox="showAchievement = null"
    v-if="showAchievement"></showAchievement>
</template>

<script>
import showAchievement from "../show-achievement/show-achievement.vue";


export default {
  name: "achievement-list",
  components: {
    showAchievement
  },
  data() {
    return {
      loading: true,
      showAchievement: null,
      certificat: null,

      show_class: [],
      allAchievementList: [],
      achievementList: [],
    }
  },

  async mounted() {
    this.getStudentRecord();
  },
  methods: {
    //查询学生所有记录
    async getStudentRecord() {
      let res = await this.$api.unifydata.getStudentRecord();
      if (res.statusCode != 200) return this.$message.warning(res.message);
      let list = res.data || [];
      //找到当前班级
      let { allAchievementList = [], platform } = this.$store.state;
      this.allAchievementList = allAchievementList;
      let show_class = [];

      let classList = await this.$api.unifydata.getClassOfUser(platform.Type).then(res => res.data || []);
      classList.forEach(item => {
        let myItem = list.find(litem => litem.classId == item.PK_ClassGuid);
        if (myItem && myItem.achievement?.length > 0) {
          show_class.push({
            class_name: item.ClassName,
            achievement: myItem.achievement,
            levelInfo: myItem.levelInfo
          })
        }
      })
      this.show_class = show_class;

      this.loading = false;
      setTimeout(() => { $('.achievement-item').height($('.achievement-item').width()) }, 100);
    }
  },
}

</script>

<style scoped lang="scss">
@import "./achievement-list.scss";
</style>
